import "./Footer.css"

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-logo">
            <i className="fas fa-cloud"></i>
            <span>WATref Calculator</span>
          </div>
          <p className="footer-description">
            A web-based platform to calculate water requirement for irrigation using reference evapotranspiration
            (WATref) models.
          </p>
        </div>

        <div className="footer-links">
          <div className="footer-section">
            <h3>Resources</h3>
            <ul>
              <li>
                <a href="/documentation">Documentation</a>
              </li>
              <li>
                <a href="/api">Forecasting</a>
              </li>
              <li>
                <a href="/models">Models</a>
              </li>
              <li>
                <a href="/weather-data">Weather Data</a>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h3>Company</h3>
            <ul>
              <li>
                <a href="/about">About Us</a>
              </li>
              <li>
                <a href="/contact">Contact</a>
              </li>
              <li>
                <a href="/privacy">Privacy Policy</a>
              </li>
              <li>
                <a href="/terms">Terms of Service</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} WATref Calculator. All rights reserved.</p>
      </div>
    </footer>
  )
}

export default Footer
